var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckbaseDarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.37783C0 6.78256 0.482567 6.29999 1.07784 6.29999H8.62276C9.21803 6.29999 9.7006 6.78256 9.7006 7.37783V14.9227C9.7006 15.518 9.21803 16.0006 8.62276 16.0006H1.07784C0.482567 16.0006 0 15.518 0 14.9227V7.37783Z",
    fill: "#EA5356"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2072 7.3881C26.2072 6.78715 26.6944 6.29999 27.2953 6.29999H34.9121C35.513 6.29999 36.0002 6.78715 36.0002 7.3881V15.0049C36.0002 15.6058 35.513 16.093 34.9121 16.093H27.2953C26.6944 16.093 26.2072 15.6058 26.2072 15.0049V7.3881Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2072 20.4454C26.2072 19.8445 26.6944 19.3573 27.2953 19.3573H34.9121C35.513 19.3573 36.0002 19.8445 36.0002 20.4454V28.0622C36.0002 28.6631 35.513 29.1503 34.9121 29.1503H27.2953C26.6944 29.1503 26.2072 28.6631 26.2072 28.0622V20.4454Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1499 7.3881C13.1499 6.78715 13.6371 6.29999 14.238 6.29999H21.8548C22.4557 6.29999 22.9429 6.78715 22.9429 7.3881V28.0622C22.9429 28.6631 22.4557 29.1503 21.8548 29.1503H14.238C13.6371 29.1503 13.1499 28.6631 13.1499 28.0622V7.3881Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckbaseDarkLogo);
export default __webpack_public_path__ + "static/media/truckbase-dark-logo.6f1a4361.svg";
export { ForwardRef as ReactComponent };